<template>
  <div class="contact-information">
    <div class="item">
      <el-popover
        placement="left-start"
        width="165"
        trigger="hover"
        :visible-arrow="false"
        v-model="visible1"
        popper-class="popper"
      >
        <div class="popover-content">
          <div class="contact-item contact-item-color">
            <div class="label">商务热线</div>
            <div class="value">173-0097-4710</div>
          </div>
          <div class="contact-item">
            <div class="label">商务座机</div>
            <div class="value">0571-87273959</div>
          </div>
        </div>
        <div class="item-content item-content1" slot="reference">
          <div class="image-box">
            <img
              src="../../assets/image/home/concat-phone.png"
              alt=""
              v-show="!visible1"
            />
            <img
              src="../../assets/image/home/concat-phone-active.png"
              alt=""
              v-show="visible1"
            />
          </div>
          <div>联系电话</div>
        </div>
      </el-popover>
    </div>
    <div class="item">
      <el-popover
        placement="left-start"
        width="165"
        trigger="hover"
        :visible-arrow="false"
        v-model="visible2"
        popper-class="popper"
      >
        <div class="popover-content">
          <div class="contact-item">
            <div class="label">客服热线</div>
            <div class="value">010-86208512</div>
          </div>
        </div>
        <div class="item-content item-content2" slot="reference">
          <div class="image-box">
            <img
              src="../../assets/image/home/concat-server.png"
              alt=""
              v-show="!visible2"
            />
            <img
              src="../../assets/image/home/concat-server-active.png"
              alt=""
              v-show="visible2"
            />
          </div>
          <div>客服热线</div>
        </div>
      </el-popover>
    </div>
    <div class="item">
      <el-popover
        placement="left-start"
        width="130px"
        :visible-arrow="false"
        v-model="visible3"
        trigger="hover"
        popper-class="popper"
      >
        <div class="popover-content">
          <div class="code">
            <img src="~@/assets/image/footer/qrcode.png" alt="" class="qrcode"/>
          </div>
        </div>

        <div class="item-content item-content2" slot="reference">
          <div class="image-box">
            <img
              src="../../assets/image/home/concat-code.png"
              alt=""
              v-show="!visible3"
            />
            <img
              src="../../assets/image/home/concat-code-active.png"
              alt=""
              v-show="visible3"
            />
          </div>
          <div>公众号</div>
        </div>
      </el-popover>
    </div>
    <div class="item">
      <el-popover
        placement="left-start"
        width="130px"
        :visible-arrow="false"
        v-model="visible4"
        trigger="hover"
        popper-class="popper"
      >
        <div class="popover-content">
          <div class="code">
            <img src="~@/assets/image/footer/weixin-qrcode.png" alt="" class="qrcode"/>
          </div>
        </div>

        <div class="item-content item-content3" slot="reference">
          <div class="image-box">
            <img
              src="../../assets/image/home/concat-code.png"
              alt=""
              v-show="!visible4"
            />
            <img
              src="../../assets/image/home/concat-code-active.png"
              alt=""
              v-show="visible4"
            />
          </div>
          <div>客服微信</div>
        </div>
      </el-popover>
    </div>
  </div>
</template>
  <script>
export default {
  components: {},
  data() {
    return {
      visible1: false,
      visible2: false,
      visible3: false,
      visible4: false,
    };
  },
  methods: {},
  components: {},
};
</script>
  
  <style lang="scss" scope>
.contact-information {
  position: fixed;
  bottom: 150px;
  right: 20px;
  z-index: 100;

  width: 76px;
  background: transparent;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  .item {
    width: 76px;
    height: 76px;
    .item-content {
      width: 76px;
      height: 76px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      font-size: 13px;
      .image-box {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        margin-bottom: 4px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .item-content1 {
      background-color: #b62229;
      border-radius: 4px 4px 0 0;
      color: #ffffff;
    }
    .item-content2 {
      background-color: #ffffff;
    }
    .item-content3 {
      background-color: #ffffff;
      border-radius: 0 0 4px 4px;
    }
  }
}

.popover-content {
  .contact-item {
    height: 78px;
    border-radius: 4px 4px 0px 0px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    padding-left: 24px;
    &.contact-item-color {
      background: linear-gradient(90deg, #eaedf0 0%, #fefefe 100%);
    }
    .label {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #474849;
      line-height: 18px;
      margin-bottom: 4px;
    }
    .value {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #b62229;
      line-height: 24px;
    }
  }

  .code {
    width: 130px;
    height: 130px;
    background: #ffffff;
    border-radius: 4px;
    img {
        width: 100%;
        height: 100%;
    }
  }
}
</style>

<style>
.popper {
  padding: 0 !important;
  min-width: 130px !important;
}
</style>
  